var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpFromLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.625 214.625L160 141.25V320C160 337.688 174.312 352 192 352S224 337.688 224 320V141.25L297.375 214.625C303.625 220.875 311.812 224 320 224S336.375 220.875 342.625 214.625C355.125 202.125 355.125 181.875 342.625 169.375L214.625 41.375C202.125 28.875 181.875 28.875 169.375 41.375L41.375 169.375C28.875 181.875 28.875 202.125 41.375 214.625S74.125 227.125 86.625 214.625ZM352 416H32C14.312 416 0 430.312 0 448S14.312 480 32 480H352C369.688 480 384 465.688 384 448S369.688 416 352 416Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpFromLine);
export default __webpack_public_path__ + "static/media/arrow-up-from-line.f1d4700ec87ee264dd20c91a6b7a6f29.svg";
export { ForwardRef as ReactComponent };